module.exports = __webpack_public_path__ + "media/images/pic/teachers/sayaka-nakai-fb23d87881aed86615f29fcee6787ab2.webp";